import Icon from '@vfz/ui/dist/components/icon/icon';
import React from 'react';
import { ContentUtil } from 'utils/content';

import { content } from './payment-pending.content';
import { Content, Link, PageWrapper, Title } from './payment-pending.styles';

const contentUtil = new ContentUtil({ content, componentName: 'PaymentPending' });

export const PaymentPending = () => {
  return (
    <PageWrapper data-testid="payment-pending">
      <Title>
        <h1>{contentUtil.translate('title')}</h1>
      </Title>
      <Content>{contentUtil.translateHtml('content')}</Content>
      <Link to="/facturen">
        <Icon name="arrowLeft" variant="solid" width={24} height={24} />
        {contentUtil.translate('linkText')}
      </Link>
    </PageWrapper>
  );
};
